/* eslint-disable no-nested-ternary */
import React, { useState } from 'react';
import PropTypes from 'prop-types';
import { formConstants } from '../utils/constants/form-constants';
import FieldHeader from './utility/FieldHeader';
import { getDestructuredText } from '../../../../general/js/utils';

function FormOffers({
    offersDetails,
    onChange,
    refuseOffersName,
    acceptOffersName,
    defaultValue,
    isDisabled
}) {
    const [isDirty, setIsDirty] = useState(false);

    const [refuseOffers, setRefuseOffers] = useState(false);
    const [acceptOffers, setAcceptOffers] = useState(false);

    const refuseOffersDefaultValueFromProps = isDirty ?
        refuseOffers : defaultValue === undefined ? false : defaultValue[formConstants.refuseOffers];
    const acceptOffersDefaultValueFromProps = isDirty ?
        acceptOffers : defaultValue === undefined ? false : defaultValue[formConstants.acceptOffers];

    if (refuseOffers !== refuseOffersDefaultValueFromProps) {
        setRefuseOffers(refuseOffersDefaultValueFromProps);
    }

    if (acceptOffers !== acceptOffersDefaultValueFromProps) {
        setAcceptOffers(acceptOffersDefaultValueFromProps);
    }

    const acceptOffersFieldTitle = offersDetails.acceptOffers.fieldHeaderTitle;
    const acceptOffersFieldText = offersDetails.acceptOffers.fieldHeaderText;

    const refuseOffersFieldTitle = offersDetails.refuseOffers.fieldHeaderTitle;
    const refuseOffersFieldText = offersDetails.refuseOffers.fieldHeaderText;

    const onRefuseCheckboxChange = (event) => {
        const checkboxValue = event.target.checked;
        setRefuseOffers(checkboxValue);
        onChange(event);
        setIsDirty(true);
    };

    const onAcceptCheckboxChange = (event) => {
        const checkboxValue = event.target.checked;
        setAcceptOffers(checkboxValue);
        onChange(event);
        setIsDirty(true);
    };

    return (!offersDetails.isHidden &&

        <div className='form-offers-container form-checkbox-panel'>
            <FieldHeader fieldName={refuseOffersName} headerTitle={refuseOffersFieldTitle} headerText={refuseOffersFieldText}>
            </FieldHeader>
            {
                !offersDetails.refuseOffers.isHidden &&
                <div className='refuse-offers-container'>
                    <h5 className='form-checkbox-panel__title' dangerouslySetInnerHTML={{ __html: offersDetails.text }} />
                    <div className='form-checkbox form-checkbox-panel__container'>
                        <label className="form-switch">
                            <input
                                type='checkbox'
                                className='form-checkbox__checkbox visually-hidden'
                                name={refuseOffersName}
                                id={refuseOffersName}
                                disabled={isDisabled}
                                onChange={onRefuseCheckboxChange}
                                checked={refuseOffers}
                            /><i></i>{offersDetails.refuseOffers.label}
                        </label>
                    </div>
                </div>
            }
            <div className='accept-offers-container'>
                <div className='form-checkbox-panel__title'>
                    {getDestructuredText(
                        offersDetails.emailConsent.label,
                        offersDetails.emailConsent.link
                    )}
                </div>
                <FieldHeader fieldName={acceptOffersName} headerTitle={acceptOffersFieldTitle} headerText={acceptOffersFieldText}>
                </FieldHeader>
                <div className='form-checkbox form-checkbox-panel__container'>
                    <label className="form-switch">
                        <input
                            type='checkbox'
                            className='form-checkbox__checkbox visually-hidden'
                            name={acceptOffersName}
                            id={acceptOffersName}
                            disabled={isDisabled}
                            onChange={onAcceptCheckboxChange}
                            checked={acceptOffers}
                        /><i></i>{offersDetails.acceptOffers.label}
                    </label>
                </div>
            </div>
        </div>
    );
}

FormOffers.propTypes = {
    offersDetails: PropTypes.object.isRequired,
    refuseOffersName: PropTypes.string.isRequired,
    acceptOffersName: PropTypes.string.isRequired,
    defaultValue: PropTypes.object,
    onChange: PropTypes.func
};

export default FormOffers;
